import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import {
  ListRequestOfBaseFilter,
  ResourceLibrary,
  ListResponseOfResourceLibrary,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import contextStore from "stores/contextStore";

type SelectResourceLibraryProps = Omit<
  AutocompleteWithQueryProps<ResourceLibrary>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectResourceLibrary = ({ ...rest }: SelectResourceLibraryProps) => {
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();
  const { organizationId } = contextStore.useState();

  const fetchedResourceLibraries = useQuery<ListResponseOfResourceLibrary>(
    ["resourceLibraries", organizationId],
    () =>
      resourceLibraryService.getResourceLibraries(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="name"
      fetchedData={fetchedResourceLibraries}
      failMessage={t({ id: "selectResourceLibraryFailed" })}
    />
  );
};

export default SelectResourceLibrary;
